import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({
  selector: 'a[boelsMousedown]',
  standalone: true,
})
export class MousedownDirective {
  #elemtentRef: ElementRef = inject(ElementRef);

  @HostListener('mousedown', ['$event'])
  onMousedown(event: MouseEvent) {
    const element = this.#elemtentRef.nativeElement as HTMLElement;
    element.dispatchEvent(new MouseEvent('click', event));
  }
}
